import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import AuthLayout from 'layout/AuthLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import ErrorBoundary from './ErrorBoundary';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login')), { branded: true, loaderVariant: 'fullscreen' });
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/Register')), { branded: true, loaderVariant: 'fullscreen' });
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/ForgotPassword')), { branded: true, loaderVariant: 'fullscreen' });
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/ResetPassword')), { branded: true, loaderVariant: 'fullscreen' });
const AuthAcceptInvite = Loadable(lazy(() => import('views/pages/authentication/AcceptInvite')), { branded: true, loaderVariant: 'fullscreen' });
const AuthCheckMail = Loadable(lazy(() => import('views/pages/authentication/CheckMail')), { branded: true, loaderVariant: 'fullscreen' });
const AuthVerifyEmail = Loadable(lazy(() => import('views/pages/authentication/VerifyEmail')), { branded: true, loaderVariant: 'fullscreen' });
const OAuthCallback = Loadable(lazy(() => import('views/pages/authentication/OAuthCallback')), { branded: true, loaderVariant: 'fullscreen' });

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  element: (
    <NavMotion>
      <GuestGuard>
        <AuthLayout />
      </GuestGuard>
    </NavMotion>
  ),
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '/',
      element: <AuthLogin />
    },
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      path: '/register',
      element: <AuthRegister />
    },
    {
      path: '/forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: '/reset-password',
      element: <AuthResetPassword />
    },
    {
      path: '/invite/accept',
      element: <AuthAcceptInvite />
    },
    {
      path: '/check-mail',
      element: <AuthCheckMail />
    },
    {
      path: '/verify-email',
      element: <AuthVerifyEmail />
    },
    {
      path: '/auth/callback',
      element: <OAuthCallback />
    }
  ]
};

export default LoginRoutes;
